import { FormType } from '@common/types';

export enum FormKey {
  Password = 'password',
  ConfirmPassword = 'confirmPassword'
}

export type PasswordFormStructure = {
  [FormKey.Password]: string;
  [FormKey.ConfirmPassword]: string;
};

export type FormStructure = FormType<PasswordFormStructure>;
